const typography = {
  fontFamily: "'Futura Allele', sans-serif",
  h1: {
    fontSize: 32,
    lineHeight: "42px",
    letterSpacing: 0.5,
    fontWeight: 600,
  },
  h2: {
    fontSize: 24,
    lineHeight: "35px",
    letterSpacing: 0.5,
    fontWeight: 600,
  },
  h3: {
    fontSize: 21,
    lineHeight: "31px",
    letterSpacing: 0.5,
    fontWeight: 600,
  },
  h4: {
    fontSize: 18,
    lineHeight: "26px",
    letterSpacing: 0.5,
    fontWeight: 600,
  },
  h5: {
    fontSize: 16,
    lineHeight: "23px",
    letterSpacing: 0.5,
    fontWeight: 600,
  },
  h6: {
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: 0.5,
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: 16,
    lineHeight: "23px",
    letterSpacing: 0.5,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: 14,
    lineHeight: "20.41px",
    letterSpacing: 1,
    fontWeight: 700,
  },
  body1: {
    fontSize: 16,
    lineHeight: "23px",
    letterSpacing: 0.5,
    fontWeight: 400,
  },
  body2: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "22px",
    letterSpacing: 0.5,
  },
  para16: {
    fontSize: 16,
    lineHeight: "23px",
    letterSpacing: 0.5,
    fontWeight: 400,
  },
  para14: {
    fontSize: 14,
    lineHeight: "20.41px",
    letterSpacing: 0.1,
    fontWeight: 400,
  },
  para12: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "17px",
    letterSpacing: 0.5,
  },
  paraSmall: {
    fontWeight: 400,
    fontSize: 10,
    lineHeight: "14.58px",
    letterSpacing: 1,
  },
  h1Mobile: {
    fontWeight: 600,
    fontSize: 21,
    lineHeight: "auto",
  },
};

export default typography;
